//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import { EventBus } from './../../events';

	export default {
		name: "rgpd",
        props: ['infos'],
        data() {
			return {
                form_id: null,
                form_url: null,
                name: null,
                title: null,
                text: null,
                text_consent: null,

                consent_id: null,
                consent_name: null,
                purpose: null,

                consent: false,
                hasConsent: false,

                user_token: null,
            }
        },
        mounted() {
            this.setData();
            setTimeout(() => {
				this.setToken();
			}, 750);
            setTimeout(() => {
				this.checkConsent();
            }, 2000);

        },
        methods: {
			setData() {
				this.user_id = this.infos.user_id;
				this.user_token = this.infos.user_token;
				this.form_id = this.infos.form_id;
				this.form_url = window.location.href;
				this.name = this.infos.name;
				this.purpose = this.infos.purpose;
				this.title = this.infos.title;
				this.text = this.infos.text;
				this.text_consent = this.infos.text_consent;
            },

            setToken() {
				//console.log(this.user_token);
				let token = this.user_token;
				if( token === null ) {
					token = Math.random().toString(36).substring(2, 30) + Math.random().toString(36).substring(2, 30) + Math.random().toString(36).substring(2, 15);
					this.user_token = token;
                }

				if (typeof localStorage !== 'undefined') {

					if( localStorage.getItem('rugbynistere_consent_token') && localStorage.getItem('rugbynistere_consent_token') !== this.user_token ) {
						//console.log('ok');
						token = localStorage.getItem('rugbynistere_consent_token');
						//console.log(token);

						setTimeout(() => {
							//console.log('update token');
							EventBus.$emit('update:consent_token', token);
						}, 1500);
					} else {
						//console.log(token);
						setTimeout(() => {
							//console.log('update token');
							EventBus.$emit('update:consent_token', token);
						}, 1500);
                    }

					this.user_token = token;
					localStorage.setItem('rugbynistere_consent_token', token);
                    //console.log(token);

				} else {
                    window.Notify.error('Votre navigateur ne semble pas supporter le stockage des données en local, nécessaire à l\'enregistrement d\'un identifiant pour retrouver vos consentements. Veuillez utiliser un navigateur plus récent.');
				}
            },

            checkConsent() {
				//console.log('checkConsent');
                window.Api.get('mes-consentements/' + this.user_token + '/' + this.purpose, 'secure').then(response => {
                    if( response.consented === true ) {
                    	this.hasConsent = true;
                    	this.consent = true;
						EventBus.$emit('update:consent', true);
                    } else if (response.consented === false ) {
                    	this.consent = false;
						EventBus.$emit('update:consent', false);
                    }
                });
            },

            onChange() {
				this.consent = !this.consent;
				EventBus.$emit('update:consent', this.consent);
            }
        }
	}
